import React, { useState } from 'react';
import {
  Box, Typography, Paper, TextField, Chip, List, ListItem, ListItemText,
  Divider, Card, CardContent, InputAdornment, Alert,
} from '@mui/material';
import { ShoppingCart, Search, Payment, QrCodeScanner } from '@mui/icons-material';
import { productos, sucursalActual, formatearMoneda, nombreTienda } from '../data';

function PointOfSale() {
  const [codigo, setCodigo] = useState('');
  const [carrito, setCarrito] = useState([]);

  const handleAgregar = (e) => {
    e.preventDefault();
    const producto = productos.find(p => p.codigo_barras === codigo.trim());
    if (!producto) return;
    const existente = carrito.find(i => i._id === producto._id);
    if (existente) {
      setCarrito(carrito.map(i => i._id === producto._id ? { ...i, cantidad: i.cantidad + 1 } : i));
    } else {
      setCarrito([...carrito, { ...producto, cantidad: 1 }]);
    }
    setCodigo('');
  };

  const subtotal = carrito.reduce((s, i) => s + i.precio_venta_publico * i.cantidad, 0);
  const total = subtotal;

  return (
    <Box>
      <Box display="flex" alignItems="center" gap={1} mb={2}>
        <Typography variant="h4" fontWeight={700}>Punto de Venta</Typography>
        <Chip label={nombreTienda(sucursalActual.codigo)} size="small" color="secondary" variant="outlined" />
      </Box>

      <Alert severity="info" sx={{ mb: 2 }}>Simulación de solo lectura. Escanea códigos de barras de ejemplo.</Alert>

      <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} gap={2}>
        <Box flex={3}>
          <Paper sx={{ p: 2, minHeight: 300, display: 'flex', flexDirection: 'column' }}>
            <Box display="flex" alignItems="center" gap={1} mb={2}>
              <ShoppingCart color="primary" />
              <Typography variant="h6">Carrito</Typography>
            </Box>

            {carrito.length === 0 ? (
              <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" flex={1} py={6}>
                <ShoppingCart sx={{ fontSize: 48, color: 'text.disabled', mb: 1 }} />
                <Typography color="text.secondary">Escanea un código para simular</Typography>
              </Box>
            ) : (
              <>
                <Box flex={1}>
                  <List dense>
                    {carrito.map((item, i) => (
                      <React.Fragment key={item._id}>
                        {i > 0 && <Divider />}
                        <ListItem>
                          <ListItemText
                            primary={<Typography variant="body2" fontWeight={500}>{item.nombre}</Typography>}
                            secondary={<Typography variant="caption" fontFamily="monospace">{item.codigo_barras}</Typography>}
                          />
                          <Box textAlign="center" mx={2}>
                            <Typography variant="body2">x{item.cantidad}</Typography>
                          </Box>
                          <Typography variant="body2" fontWeight={600} minWidth={80} textAlign="right">
                            {formatearMoneda(item.precio_venta_publico * item.cantidad)}
                          </Typography>
                        </ListItem>
                      </React.Fragment>
                    ))}
                  </List>
                </Box>
                <Divider sx={{ my: 1 }} />
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="h6" fontWeight={700}>Total</Typography>
                  <Typography variant="h5" fontWeight={700} color="primary">{formatearMoneda(total)}</Typography>
                </Box>
              </>
            )}
          </Paper>
        </Box>

        <Box flex={2}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>Escanear</Typography>

            <Box component="form" onSubmit={handleAgregar} mb={3}>
              <TextField
                placeholder="Código de barras (ejemplo)..."
                value={codigo}
                onChange={(e) => setCodigo(e.target.value)}
                size="small"
                fullWidth
                autoFocus
                InputProps={{
                  startAdornment: <InputAdornment position="start"><QrCodeScanner color="primary" fontSize="small" /></InputAdornment>,
                }}
                helperText="Prueba: 7501001001001 (Camiseta)"
              />
            </Box>

            <Typography variant="subtitle2" gutterBottom>Códigos de ejemplo:</Typography>
            {productos.slice(0, 5).map((p) => (
              <Card key={p._id} variant="outlined" sx={{ mb: 0.5, cursor: 'pointer', '&:hover': { borderColor: 'primary.main' } }}
                onClick={() => {
                  const existente = carrito.find(i => i._id === p._id);
                  if (existente) {
                    setCarrito(carrito.map(i => i._id === p._id ? { ...i, cantidad: i.cantidad + 1 } : i));
                  } else {
                    setCarrito([...carrito, { ...p, cantidad: 1 }]);
                  }
                }}
              >
                <CardContent sx={{ py: 1, px: 1.5, '&:last-child': { pb: 1 } }}>
                  <Box display="flex" justifyContent="space-between">
                    <Typography variant="body2" fontWeight={500}>{p.nombre}</Typography>
                    <Typography variant="body2" fontWeight={600} color="primary">{formatearMoneda(p.precio_venta_publico)}</Typography>
                  </Box>
                  <Typography variant="caption" fontFamily="monospace" color="text.secondary">{p.codigo_barras}</Typography>
                </CardContent>
              </Card>
            ))}
          </Paper>
        </Box>
      </Box>
    </Box>
  );
}

export default PointOfSale;
